import classNames from 'classnames';
import { env } from '@/utils/constants/env';

// Palet warna pastel dengan soft background dan darker border
const PASTEL_COLORS = [
  { bg: 'bg-rose-100', border: 'ring-rose-400', text: 'text-rose-700' },
  { bg: 'bg-pink-100', border: 'ring-pink-400', text: 'text-pink-700' },
  { bg: 'bg-fuchsia-100', border: 'ring-fuchsia-400', text: 'text-fuchsia-700' },
  { bg: 'bg-purple-100', border: 'ring-purple-400', text: 'text-purple-700' },
  { bg: 'bg-violet-100', border: 'ring-violet-400', text: 'text-violet-700' },
  { bg: 'bg-indigo-100', border: 'ring-indigo-400', text: 'text-indigo-700' },
  { bg: 'bg-blue-100', border: 'ring-blue-400', text: 'text-blue-700' },
  { bg: 'bg-sky-100', border: 'ring-sky-400', text: 'text-sky-700' },
  { bg: 'bg-cyan-100', border: 'ring-cyan-400', text: 'text-cyan-700' },
  { bg: 'bg-teal-100', border: 'ring-teal-400', text: 'text-teal-700' },
  { bg: 'bg-emerald-100', border: 'ring-emerald-400', text: 'text-emerald-700' },
  { bg: 'bg-green-100', border: 'ring-green-400', text: 'text-green-700' },
  { bg: 'bg-lime-100', border: 'ring-lime-400', text: 'text-lime-700' },
  { bg: 'bg-yellow-100', border: 'ring-yellow-400', text: 'text-yellow-700' },
  { bg: 'bg-amber-100', border: 'ring-amber-400', text: 'text-amber-700' },
  { bg: 'bg-orange-100', border: 'ring-orange-400', text: 'text-orange-700' },
];

// Mendapatkan inisial dari nama (2 huruf pertama)
function getInitials(name: string): string {
  if (!name) return '?';
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

// Mendapatkan warna pastel berdasarkan nama (konsisten)
function getPastelColor(name: string): { bg: string; border: string; text: string } {
  if (!name) return PASTEL_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % PASTEL_COLORS.length;
  return PASTEL_COLORS[index];
}

interface AvatarProps {
    name: string;
    imagePath?: string | null;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeClasses = {
  sm: 'h-5 w-5 text-[8px]',
  md: 'h-6 w-6 text-[10px]',
  lg: 'h-8 w-8 text-xs',
};

export default function Avatar({ name, imagePath, size = 'md', className }: AvatarProps) {
  let resolvedImagePath: string | null = null;
  if (imagePath?.startsWith('htt')) {
    resolvedImagePath = imagePath;
  } else if (imagePath) {
    resolvedImagePath = env.cloudStorage + imagePath;
  }

  const color = getPastelColor(name);

  if (resolvedImagePath) {
    return (
      <div
        className={classNames(
          'bg-white aspect-square flex items-center justify-center rounded-full overflow-hidden ring-1 ring-gray-200 shadow-sm',
          sizeClasses[size],
          className
        )}
      >
        <img src={resolvedImagePath} alt={`${name} avatar`} className="w-full h-full aspect-square object-cover" />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'aspect-square flex items-center justify-center rounded-full font-medium ring-1',
        sizeClasses[size],
        color.bg,
        color.border,
        color.text,
        className
      )}
    >
      {getInitials(name)}
    </div>
  );
}

// Re-export for backward compatibility
export { Avatar };
